import React, { useState } from "react";
import { toast } from "react-toastify";
import { ProgressBar } from "react-bootstrap";
import LogoSmall from "../../assets/images/logo-small.png";
import floatingSound from "../../assets/audios/floating-notification-tone.wav";
import {
  formatImportJobStatusNotificationResult,
  formatProductCatalogueImportResult,
} from "./importNotificationFormatter";

export const ProductCatalogueImportNotificationMessage = ({ model }) => {
  const [showIssues, setShowIssues] = useState(false);

  return (
    <div className="app-notification-container">
      <ProgressBar
        now={model.progressPercent || 0}
        className="notification-progress-bar"
      />
      <div
        className={`import-toast-title ${model.hasWarnings ? "import-toast-title-warning" : ""}`}
      >
        {model.title}
      </div>
      {model.lines.map((line, index) => (
        <div key={`import-line-${index}`}>{line}</div>
      ))}

      {model.issueCount > 0 && (
        <>
          <span
            className="redirect-link"
            onClick={() => setShowIssues((prev) => !prev)}
          >
            {showIssues
              ? "Hide issues"
              : `View ${model.issueCount} ${model.issueCount === 1 ? "issue" : "issues"}`}
          </span>
          {showIssues && (
            <div className="import-issues-list">
              {model.groupedIssues.map((group) => (
                <div key={group.label} className="import-issue-group">
                  <div className="import-issue-group-title">{group.label}</div>
                  {group.description && (
                    <div className="import-issue-group-description">
                      {group.description}
                    </div>
                  )}
                  {group.codes.map((code, index) => (
                    <div
                      key={`${group.label}-code-${index}`}
                      className="import-issue-item"
                    >
                      <span className="import-issue-bullet">•</span>
                      <span className="import-issue-message">{code}</span>
                    </div>
                  ))}
                  {group.texts.map((text, index) => (
                    <div
                      key={`${group.label}-text-${index}`}
                      className="import-issue-item"
                    >
                      <span className="import-issue-bullet">•</span>
                      <span className="import-issue-message">{text}</span>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export const showProductCatalogueImportNotification = (payload) => {
  const model = formatProductCatalogueImportResult(payload);

  toast.dismiss();
  return toast(<ProductCatalogueImportNotificationMessage model={model} />, {
    icon: () => <img src={LogoSmall} width={35} alt="" />,
    className: "app-notification",
    autoClose: model.autoClose || (model.hasWarnings ? 8000 : 5000),
    data: {
      sound: new Audio(floatingSound),
    },
  });
};

export const showImportJobStatusNotification = (statusMap, toastId = null) => {
  const model = formatImportJobStatusNotificationResult(statusMap);
  const render = <ProductCatalogueImportNotificationMessage model={model} />;

  if (toastId && toast.isActive(toastId)) {
    toast.update(toastId, {
      render,
      className: "app-notification",
      autoClose: model.autoClose,
    });
    return toastId;
  }

  toast.dismiss();
  return toast(render, {
    icon: () => <img src={LogoSmall} width={35} alt="" />,
    className: "app-notification",
    autoClose: model.autoClose,
    data: {
      sound: new Audio(floatingSound),
    },
  });
};
